import { createSlice, current } from '@reduxjs/toolkit';
import {
	getWorkOrderStatusList,
	getWorkOrderStatus,
	addNewWorkOrderStatus,
	updateWorkOrderStatus,
	deleteWorkOrderStatus,
	checkWorkOrderStatusExists,
} from './thunk';

export const initialState = {
	itemWorkOrderStatusList: [],
	itemWorkOrderStatus: null,
	isWorkOrderStatusLoading: false,
	isWorkOrderStatusSuccess: false,
	dataWorkOrderStatus: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const WorkOrderStatusSlice = createSlice({
	name: 'WorkOrderStatus',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getWorkOrderStatusList.pending, state => {
			state.isLoadingList = true;
			state.isWorkOrderStatusSuccess = false;
		});

		builder.addCase(getWorkOrderStatusList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemWorkOrderStatusList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isWorkOrderStatusSuccess = true;
		});

		builder.addCase(getWorkOrderStatusList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isWorkOrderStatusSuccess = false;
		});

		builder.addCase(getWorkOrderStatus.pending, state => {
			state.isWorkOrderStatusLoading = true;
			state.isWorkOrderStatusSuccess = false;
		});

		builder.addCase(getWorkOrderStatus.fulfilled, (state, action) => {
			state.itemWorkOrderStatus = action.payload;
			state.isWorkOrderStatusLoading = false;
			state.isWorkOrderStatusSuccess = true;
		});

		builder.addCase(getWorkOrderStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isWorkOrderStatusLoading = false;
			state.isWorkOrderStatusSuccess = false;
		});

		builder.addCase(addNewWorkOrderStatus.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewWorkOrderStatus.fulfilled, (state, action) => {
			state.itemWorkOrderStatusList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewWorkOrderStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateWorkOrderStatus.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateWorkOrderStatus.fulfilled, (state, action) => {
			state.itemWorkOrderStatusList = state.itemWorkOrderStatusList.map(
				item =>
					item._id.toString() === action.payload._id.toString()
						? { ...item, ...action.payload }
						: item
			);
			state.statementList = state.statementList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
							item: action.payload,
							value: action.payload._id,
							label: action.payload.name,
					  }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateWorkOrderStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteWorkOrderStatus.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteWorkOrderStatus.fulfilled, (state, action) => {
			state.itemWorkOrderStatusList = current(
				state.itemWorkOrderStatusList
			).filter(item => item._id !== action.payload._id);
			state.statementList = current(state.statementList).filter(
				item => item._id !== action.payload._id
			);
			state.statementListSelect = current(state.statementListSelect).filter(
				item => item.value !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteWorkOrderStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkWorkOrderStatusExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkWorkOrderStatusExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkWorkOrderStatusExists.rejected, state => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = WorkOrderStatusSlice.actions;

export default WorkOrderStatusSlice.reducer;
